module.exports = __webpack_public_path__ + "fonts/20ffa4b4-0154-4ca6-800c-468cecbd60f1.1c09434.woff";